import { PillItem } from "@search/api/types";
import { EPOCH_DATE } from "@search/store/constants";
import BaseFilter from "@search/store/filters/base/BaseFilter";
import { formatISO, isEqual } from "date-fns";

class DateFilter extends BaseFilter {
  constructor(value: Date) {
    super({ defaultValue: EPOCH_DATE, name: "date", value: value as Date });
  }

  get defaultValue() {
    return super.defaultValue as Date;
  }

  get value() {
    return super.value as Date;
  }

  isSet() {
    return super.isSet() && !isEqual(this.value, this.defaultValue);
  }

  toParam() {
    if (!this.isSet()) {
      return "";
    }

    return formatISO(this.value, { representation: "date" });
  }

  toPills(): Array<PillItem> {
    const pills: Array<PillItem> = [];

    if (this.isSet()) {
      pills.push({
        key: this.toParam(),
        name: this.name,
      });
    }

    return pills;
  }
}

export default DateFilter;
export { DateFilter };
